
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import { Select, MenuItem, Button, FormControl, InputLabel } from '@mui/material';
import { Typography, Card, Container, CardMedia, CardHeader, CardContent } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import { red } from '@mui/material/colors';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import IconButton from '@mui/material/IconButton';
import LoadingButton from '@mui/lab/LoadingButton';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckIcon from '@mui/icons-material/Check';
import { getUfficioPostaleId } from './ApiManagedAffissioni'; // Assicurati che il percorso sia corretto
import Grid from '@mui/material/Grid2';
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import createAuthInterceptor from '../../../utils/authInterceptor';
const { REACT_APP_API_ENDPOINT } = process.env;


const ManagedPanelAffissioni = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [regioni, setRegioni] = useState([]);
  const [citta, setCitta] = useState([]);
  const [ufficio, setUfficio] = useState([]);
  const [selectedCampaigns, setSelectedCampaigns] = useState('');
  const [selectedAnno, setSelectedAnno] = useState('');
  const [selectedRegione, setSelectedRegione] = useState('');
  const [selectedCitta, setSelectedCitta] = useState('');
  const [selectedUfficio, setSelectedUfficio] = useState('');
  const [images, setImages] = useState([]);
  const [open, setOpen] = useState(false);
  const [conflict, setConflict] = useState('');

  const [ufficioId, setUfficioId] = useState({})

  const [noRecordFound, setNoRecordFound] = useState(false);
  const [loading, setLoading] = useState(false);
  const [noInsertion, setNoInsertion] = useState(false);

  const navigate = useNavigate();

  const axiosInstance = createAuthInterceptor(navigate);

  // ligthbox
const [index, setIndex] = useState(-1);
const currentImage = images[index];
const nextIndex = (index + 1) % images.length;
const nextImage = images[nextIndex] || currentImage;
const prevIndex = (index + images.length - 1) % images.length;
const prevImage = images[prevIndex] || currentImage;

const handleClick = (index, item) => setIndex(index);
const handleClose = () => setIndex(-1);
const handleMovePrev = () => setIndex(prevIndex);
const handleMoveNext = () => setIndex(nextIndex);

  // Per recuperare le campagne disponibili dal backend
  useEffect(() => {
    const fetchCampaigns = async () => {
      try {
        const response = await axiosInstance.get(`${REACT_APP_API_ENDPOINT}/api/campaigns-affissioni-managed-foto`);
        setCampaigns(response.data);
      } catch (error) {
        console.error('Errore nel recupero delle campagne:', error);
      }
    };

    fetchCampaigns();
  }, []);


  

  // Per recuperare le regioni disponibili dal backend
  useEffect(() => {
    const fetchRegioni = async () => {
      try {
        const response = await axiosInstance.get(`${REACT_APP_API_ENDPOINT}/api/affissioni/regions`);
        setRegioni(response.data);
      } catch (error) {
        console.error('Errore nel recupero delle regioni:', error);
      }
    };

    fetchRegioni();
  }, []);

  // Quando una regione è selezionata, recupera le città corrispondenti
  useEffect(() => {
    if (selectedRegione) {
      const fetchCitta = async () => {
        try {
          const response = await axiosInstance.get(`${REACT_APP_API_ENDPOINT}/api/affissioni/citta?region=${selectedRegione}`);
          setCitta(response.data);
        } catch (error) {
          console.error('Errore nel recupero delle città:', error);
        }
      };

      fetchCitta();
    }
  }, [selectedRegione]);

  // Quando una città è selezionata, recupera i ufficio corrispondenti
  useEffect(() => {
    if (selectedCitta) {
      const fetchUffici = async () => {
        try {
          const response = await axiosInstance.get(`${REACT_APP_API_ENDPOINT}/api/affissioni/uffici?citta=${selectedCitta}`);
          setUfficio(response.data);
        } catch (error) {
          console.error('Errore nel recupero dei uffici:', error);
        }
      };
      
      fetchUffici();
    }
  }, [selectedCitta]);


      // recupera l' _id dell'uficio per perjointare i mq
useEffect(() => {
  const fetchUfficioId = async () => {
      if (selectedUfficio) {
        const response = await getUfficioPostaleId(selectedUfficio);
        setUfficioId(response);
      }
    };

    fetchUfficioId();
}, [selectedUfficio])

  const handleFilter = async () => {

    setConflict('');
        setNoInsertion(false);
        setNoRecordFound(false);
    try {
      // Invio di una richiesta con i parametri di filtro
      const response = await axiosInstance.get(`${REACT_APP_API_ENDPOINT}/api/managed/affissioni/campaign/images`, {
        params: {
          campaignId: selectedCampaigns,
          regione: selectedRegione,
          citta: selectedCitta,
          denominazione: selectedUfficio,
        },
      });

      console.log('Immagini filtrate:', response.data);
      // Gestione delle immagini filtrate
      setImages(response.data);
      if(response.data.length > 0) {
        setNoRecordFound(false);
      } else {
        setNoRecordFound(true);
      }
    } catch (error) {
      console.error('Errore nel recupero delle immagini:', error);
    }
  };
  // ... altro codice

  const handleComplete = () => {
    setConflict('');
    axios
      .post(`${REACT_APP_API_ENDPOINT}/api/managed/uffici/completed`, {     
          campaignId: selectedCampaigns,
          ufficioId: ufficioId._id,
          anno: selectedAnno,
      })
      .then((response) => {
        console.log('completed:', response.data);
        setConflict('Completato con successo');
        setNoInsertion(false);
        setNoRecordFound(false);
        // Gestione delle immagini filtrate
        console.log(response.data)
      })
      .catch((error) => {
        setConflict(error.response.data.message);
        setNoInsertion(false);
        console.error('Errore nell\'inserimento:', error);
      });
  }

  const handleRemoveComplete = () => {
    axios.post(`${REACT_APP_API_ENDPOINT}/api/managed/uffici/removecompleted`, {     
          campaignId: selectedCampaigns,
          ufficioId: ufficioId._id,
      })
      .then((response) => {
        console.log('completed:', response.data);
        // Gestione delle immagini filtrate
        setConflict('Record Invalidato con successo');
        console.log(response.data)
      })
      .catch((error) => {
        console.error('Errore nell\'inserimento:', error);
        alert("Errore nel validare il l'ufficio: contatta l'amministatore");
      });
  } 

  const handleReset = () => {
   
   setSelectedRegione('');
   setSelectedCitta('');
   setSelectedUfficio('');
   console.log("resetto")
   setLoading(false);
}

const handleDelete = async (imageId, index) => {
    try {
      console.log(imageId)
      await axiosInstance.get(`/api/images/delete-image/${imageId}`);
      setImages(images.filter((image) => image._id !== imageId));
      enqueueSnackbar('Immagine eliminata con successo', { variant: 'success' });

    } catch (error) {
      console.error('Errore durante l\'eliminazione dell\'immagine:', error);
    }
  };


  const handleValidateImages = async () => {
  const imageIds = images.map((image) => image._id);

  try {
    const response = await axiosInstance.put('/api/images/validate', { ids: imageIds });
    console.log(response.data.message);
    alert(response.data.message);
    handleFilter();
    setNoInsertion(false);
    setNoRecordFound(false);
    // Aggiorna lo stato o notifica il successo
  } catch (error) {
    console.error("Error validating images:", error);
    alert(error);
    // Gestisci l'errore, ad esempio mostrando una notifica
  }
};

 

  return (
    <Container >
    <div style={{ marginBottom: '25px' }}>
      <h2>Managed Panel Affissioni - Filtra per Campagna uffici</h2>
      </div>
      <Stack direction="row" spacing={1} sx={{mb: 2}}>
      {loading ? 
        <CircularProgress color="inherit" />
        : <IconButton aria-label="delete" onClick={()=> { setLoading(true); handleReset();} }>
        <AutorenewIcon />
      </IconButton> }
      <Box sx={{ '& > button': { m: 1 } }}>
      {loading ? 
        <LoadingButton
          size="small"
          
          loading={loading}
          variant="outlined"
          disabled
        >
          Disabled
        </LoadingButton>
        : null }
        </Box>
    </Stack>
      <Grid container spacing={1} style={{marginBottom: '25px'}}>

      {/* 
    <Grid size={4}>
      <Grid item={true}  xs={12} sm={5} md={4}>
      <FormControl  fullWidth >
        <InputLabel id="select-anno-label">Seleziona Anno</InputLabel>
        <Select
        style={{padding:'4px 4px'}}
        value={selectedAnno}
        onChange={(e) => setSelectedAnno(e.target.value)}
        labelId="anno-select-label"
        label={"Seleziona Anno"}
        >
        <MenuItem key={'2024'} value={'2024'}>
              {'2024'}
            </MenuItem>
        </Select>
      </FormControl>
      </Grid>
    </Grid>
    */}
    
        <Grid size={6}>
          <Grid item={true}  xs={12} sm={5} md={4}>
          <FormControl  fullWidth >
            <InputLabel id="select-campaign-label">Seleziona Campagna</InputLabel>
            <Select
            style={{padding:'4px 4px'}}
            value={selectedCampaigns}
            onChange={(e) => setSelectedCampaigns(e.target.value)}
            labelId="test-select-label"
            label={"Seleziona Campagna"}
            >
              {campaigns.map((campain) => (
                <MenuItem key={campain._id} value={campain._id}>
                  {campain.denominazione} - {campain.anno}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          </Grid>
        </Grid>

        <Grid size={6}>
        <Grid item={true}  xs={12} sm={5} md={4}>
          <FormControl fullWidth >
              <InputLabel id="select-region-label">Seleziona Regione</InputLabel>
              <Select
               style={{padding:'4px 4px'}}
                value={selectedRegione}
                onChange={(e) => setSelectedRegione(e.target.value)}
                labelId="regio-select-label"
                label={"Seleziona Regione"}
              >
                {regioni.map((regione) => (
                  <MenuItem key={regione} value={regione}>
                    {regione}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

        </Grid>

        <Grid size={6}>
        <Grid item={true}  xs={12} sm={5} md={4}>
          <FormControl fullWidth >
              <InputLabel id="select-citta-label">Seleziona Città</InputLabel>
              <Select
              style={{padding:'4px 4px'}}
                value={selectedCitta}
                onChange={(e) => setSelectedCitta(e.target.value)}
                disabled={!selectedRegione} // Disabilita il selettore città finché la regione non è selezionata
                labelId="citta-select-label"
                label={"Seleziona Città"}
              >
                {citta.map((city) => (
                  <MenuItem key={city} value={city}>
                    {city}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Grid size={6}>
        <Grid item={true}  xs={12} sm={5} md={4}>
          <FormControl fullWidth >
              <InputLabel id="ufficio postale">Ufficio</InputLabel>
              <Select
                style={{padding:'4px 4px'}}
                value={selectedUfficio}
                onChange={(e) => setSelectedUfficio(e.target.value)}
                disabled={!selectedCitta} // Disabilita il selettore ufficio finché la città non è selezionata
                labelId="ufficio-select-label"
                label={"Seleziona Ufficio postale"}
              >
                {ufficio.map((g) => (
                  <MenuItem key={g} value={g}>
                    {g}
                  </MenuItem>
                ))}
              </Select>
            </FormControl >
          </Grid>
        </Grid>
        <Grid size={3}>
      <Button
              variant="contained" color="success" 
              onClick={handleFilter}
              sx={{float: 'left'}}
            >
              Filtra Immagini
      </Button>


        </Grid>
        <Grid size={3}>
        <Button
                variant="outlined"
                color="success"
                onClick={handleComplete}
                sx={{float: 'right'}}
              >
                Imposta come completato
              </Button>
          </Grid>

          <Grid size={3}>
        <Button
                variant="outlined"
                onClick={handleRemoveComplete}
                sx={{float: 'right'}}
              >
                Imposta come NON completato
              </Button>
          </Grid>
          <Grid size={3}>
        <Button
                variant="outlined" color="secondary"
                onClick={handleValidateImages}
                sx={{float: 'right'}}
              >
                Valida le foto filtrate
              </Button>
          </Grid>
      </Grid>

      {noRecordFound ?  
        <h2>
        Nessuna immagine trovata
        </h2> 
        : null
      }
      { 
        noInsertion ?
        <h2>
        Inserito con successo
        </h2> 
        :
        null
      }
      {
        <h1>{conflict}</h1>
      }
      <Grid container spacing={{ xs: 2, md: 2 }} columns={{ xs: 4, sm: 8, md: 12 }}>
      {images.map((image, index) => (
          <Grid key={image._id} size={{ xs: 2, sm: 4, md: 4 }}>
            
            <Card key={image._id} sx={{ maxWidth: 345 }}>
            <CardHeader
                avatar={
                  <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
                  <LocationOnIcon />
                  </Avatar>
                }
                action={
                  <>
          <IconButton aria-label="settings" sx={{ color: 'red' }} onClick={() => handleDelete(image._id, index)}>
            <DeleteIcon />
          </IconButton>
          {image.status === "validated" ? 
            <IconButton aria-label="settings" sx={{ color: 'red' }} disabled>
            <CheckIcon sx={{color: 'green'}} />
          </IconButton>
          : null
          }
          </>
        }
                title={image.ufficioPt.denominazione}
                subheader={`MTb:${image.ufficioPt.MTb} - MTh:${image.ufficioPt.MTh}`}
              />
              <CardMedia
                component="img"
                height="140"
                image={`${REACT_APP_API_ENDPOINT}/api/${image.path}`}
                alt="Immagine"
                onClick={()=>handleClick(index)}
              />
              <CardContent>
                {/*<Typography variant="body2" color="text.secondary">
                {image.ufficioPt.denominazione}
                </Typography>*/}
                {image.note &&
                <Typography variant="body2" color="orangered" >
                  Note: {image.note}
                  </Typography>
                }
                <Typography variant="body2" color="text.secondary">
                   Utente: {image.username}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Data: {new Date(image.uploadDate).toLocaleString()}
                </Typography>
              </CardContent>
            </Card>
           
          </Grid>
        ))}
      </Grid>
      {!!currentImage && (
        /* @ts-ignore */
        <Lightbox
          mainSrc={`${REACT_APP_API_ENDPOINT}/api/${currentImage.path}`}
          imageTitle={`${currentImage.ufficioPt.denominazione} - MTb:${currentImage.ufficioPt.MTb} - MTh:${currentImage.ufficioPt.MTh} - ${new Date(currentImage.uploadDate).toLocaleDateString()}`}
          mainSrcThumbnail={currentImage.path}
          nextSrc={`${REACT_APP_API_ENDPOINT}/api/${nextImage.path}`}
          nextSrcThumbnail={`${REACT_APP_API_ENDPOINT}/api/${nextImage.path}`}
          prevSrc={`${REACT_APP_API_ENDPOINT}/api/${prevImage.path}`}
          prevSrcThumbnail={`${REACT_APP_API_ENDPOINT}/api/${prevImage.path}`}
          onCloseRequest={handleClose}
          onMovePrevRequest={handleMovePrev}
          onMoveNextRequest={handleMoveNext}
        />
      )}



</Container >
  );
};

export default ManagedPanelAffissioni;
